export const GET_RCREPORTS_STARTED = "GET_RCREPORTS_STARTED";
export const GET_RCREPORTS_COMPLETED = "GET_RCREPORTS_COMPLETED";
export const GET_RCREPORTS_FAILED = "GET_RCREPORTS_FAILED";
export const GET_REFRESH_STARTED = "GET_REFRESH_STARTED";
export const GET_REFRESH_COMPLETED = "GET_REFRESH_COMPLETED";
export const GET_REFRESH_FAILED = "GET_REFRESH_FAILED";
export interface IAaroles {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    aarolesInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    autoid: number;
    isLoading: boolean;
    error: string;
}


export const getRCREPORTSList = (autoid) => {
    //alert("newid");
    return {
        type: GET_RCREPORTS_STARTED ,
        payload: 'Value',
        input:autoid
    };
};
export const getREFRESHList = (autoid) => {
    //alert("newid");
    return {
        type: GET_REFRESH_STARTED ,
        payload: 'Value',
        input:autoid
    };
};